import React, { Component } from 'react';
import formDataSchema from '../../../schema/tat-report';
import logSchema from '../../../schema/log-report';
// import Inputlayer from '../../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import { Table, Tag } from 'antd';

import { Pagination } from 'antd';
import moment from 'moment';
import { CSVLink } from "react-csv";
import * as R from 'ramda';
// import Pagination from "react-js-pagination";
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import DateRange from '../../../components/FormComponent/DateRange';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
const $ = require('jquery');
const {homepage} = networkList;
let i =0;
class TAT_Report extends Component {
    // print = () => {
    //     window.print();
    // }

    csvLink = React.createRef()

    constructor(props) {
        super(props);
        this.state = {
            date: '',
            appTime: [],
            headding: null,
            postdata: {},
            formData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItemsCount: 0,
            isLoading: false,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            'downloadtbody': [],
            search: "",
            inputSearch: "",
            search_key: ''
        };
    }

    componentDidMount() {
        let { slug } = this.props.match.params;
    //    if(slug==='log-report'){
    //     // let fSchema = Object.assign({}, logSchema);
    //     // fSchema['feilds'].map((feild, key) => {
    //     //     fSchema['feilds'][key]['value'] = null;
    //     //     fSchema['feilds'][key]['valid'] = false;
    //     //     fSchema['feilds'][key]['errors'] = [];
    //     //     delete fSchema['feilds'][key]['text'];

    //     // })
    //     // this.setState(({ 'formData': fSchema['feilds'] }), () => {
    //     //     this.fetchData(this.state.formData);
    //         // this.renderHead();
    //         this.loadPage()
    //     // })
    //    } else{
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState(({ search_key: '', 'formData': formSchema['feilds'] }), () => {
            this.fetchData(this.state.formData);
            // this.renderHead();
            this.loadPage()
        })
    //    }

    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({
                    'loadding': true, dateTo: moment().format('YYYY-MM-DD'),
                    activePage: 1,
                    totalItemsCount: 0,
                    dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
                    'thead': [],
                    'tbody': [],
                    'downloadtbody': [],
                }), () => {
                    this.loadPage();
                })

                // if(slug==='log-report'){
                    // let fSchema = Object.assign({}, logSchema);
                    // fSchema['feilds'].map((feild, key) => {
                    //     fSchema['feilds'][key]['value'] = null;
                    //     fSchema['feilds'][key]['valid'] = false;
                    //     fSchema['feilds'][key]['errors'] = [];
                    //     delete fSchema['feilds'][key]['text'];
            
                    // })
                    // this.setState(({ 'formData': fSchema['feilds'] }), () => {
                    //     this.fetchData(this.state.formData);
                        // this.renderHead();
                        this.loadPage()
                    // })
                //    }
                //    else{
                    let formSchema = Object.assign({}, formDataSchema);
                    formSchema['feilds'].map((feild, key) => {
                        formSchema['feilds'][key]['value'] = null;
                        formSchema['feilds'][key]['valid'] = false;
                        formSchema['feilds'][key]['errors'] = [];
                        delete formSchema['feilds'][key]['text'];
            
                    })
                    this.setState(({ 'formData': formSchema['feilds'] }), () => {
                        this.fetchData(this.state.formData);
                        // this.renderHead();
                        this.loadPage()
                    })
                //    }
            }
            
        
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    fetchData(fetchData) {
        var payload = {
            "unit_id": null,
            "from_date": this.state.dateFrom,
            "to_date": this.state.dateTo,
            "page": this.state.activePage
        }
        console.log('payload:', payload);
    }

    // renderHead(){
    //     const { slug } = this.props.match.params;
    //     let headding = null;
    //     if(slug === 'tat-reports'){
    //         headding = 'TAT Reports';
    //     }

    //     this.setState((state) => ({ 'headding': headding }))
    // }

    loadPage = (isDatefilter = false) => {
        try {
            let { activePage,search_key } = this.state;
            let { slug } = this.props.match.params;
            const { getTokenTatReport, getRecounsellingReport, getPlannedAdmissionsReport, getEstimateVarianceReport, getIdleTatReport, getBillTrackingTatReport,getRemarksReport,getLogReport } = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            this.setState({downloadStatus: 0})
            // let data = {
            //     "from": this.state.dateFrom,
            //     "to": this.state.dateTo
            // }
            // console.log('data:', data)
            switch (slug) {
                case 'tat-reports':
                    tableHead = [
                        {
                            "key": 'token_number',
                            'label': 'Token Number'
                        }, {
                            "key": 'token_issue_date',
                            'label': 'Token Issue Date'
                        },
                          {
                            "key": 'ip',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'served_privilege_name',
                            'label': 'Privilege Served'
                        },
                        {
                            "key": 'counsellor_name',
                            'label': 'Counsellor Name'
                        }, 
                        {
                            "key": 'token_assigned_time',
                            'label': 'Token Assigned Time'
                        },{
                            "key": 'checkin_time',
                            'label': 'Check In Time',
                        }, {
                            "key": 'checkout_time',
                            'label': 'Check Out Time'
                        },
                        {
                            "key": 'tat1',
                            'label': 'TAT 1 Waiting Time (Min)'
                        },
                        {
                            "key": 'tat2',
                            'label': 'TAT 2 Transaction Time (Min)'
                        },
                        {
                            "key": 'skip_status',
                            'label': 'Token Skip'
                        },
                        {
                            "key": 'token_status',
                            'label': 'Token Cancelled'
                        },
                        
                        {
                            "key": 'token_cancelled_by',
                            'label': 'Token Cancelled By'
                        },
                        {
                            "key": 'token_cancelled_at',
                            'label': 'Token Cancelled At'
                        },
                        
                        {
                            "key": 'doctor_tagged_fc',
                            'label': 'Doctor Tagged Status'
                        },
                        {
                            "key": 'icu_tagged_fc',
                            'label': 'ICU Tagged Status'
                        },
                        {
                            "key": 'counselling_station_name',
                            'label': 'Counselling Station'
                        },
                        {
                            "key": 'token_generated_by',
                            'label': 'Token generated by'
                        }, 
                        {
                            "key": 'skip1_time',
                            'label': 'Skip1 Time'
                        }, 
                        {
                            "key": 'skip1_done_by',
                            'label': 'Skip1 Done By '
                        },
                        {
                            "key": 'skip2_time',
                            'label': 'Skip2 Time'
                        }, 
                        {
                            "key": 'skip2_done_by',
                            'label': 'Skip2 Done By '
                        }, 
                        {
                            "key": 'skip3_time',
                            'label': 'Skip3 Time'
                        }, 
                        {
                            "key": 'skip3_done_by',
                            'label': 'Skip3 Done By '
                        },
                        {
                            "key": 'skip4_time',
                            'label': 'Skip4 Time'
                        }, 
                        {
                            "key": 'skip4_done_by',
                            'label': 'Skip4 Done By '
                        },
                        {
                            "key": 'skip5_time',
                            'label': 'Skip5 Time'
                        }, 
                        {
                            "key": 'skip5_done_by',
                            'label': 'Skip5 Done By '
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        // {
                        //     "key": 'digital_sig_weblink',
                        //     'label': 'Digital signature link sent'
                        // },
                        {
                            "key": 'digital_sig_weblink',
                            'label': 'SMS OTP sent'
                        },
                        // {
                        //     "key": 'digital_sig_number',
                        //     'label': 'Digital signature link sent mobile number'
                        // },
                        {
                            "key": 'phone_number',
                            'label': 'SMS OTP sent mobile number'
                        },
                        // {
                        //     "key": 'digital_sig_imgpath',
                        //     'label': 'Digital signature captured'
                        // },
                        {
                            "key": 'digital_sig_weblink',
                            'label': 'OTP Varified'
                        },
                        {
                            "key": 'patient_digsign_willing',
                            'label': 'patient unavailable/ unwilling check box marked'
                        },
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'TAT Report', thead: tableHead, filename: 'Tat-Report.csv', loadding: true, download_btn: true, select2: false, search: false ,inputSearch:true}), () => {
                        postService(getTokenTatReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "search_key":search_key,
                                "export": 0,
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('tat report:', res.data);
                            if (res.status) {
                                res.data.map((data, key) => {
                                    Object.keys(data).map((dataKey) => {
                                        if (dataKey === 'token_issue_date') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'checkin_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'checkout_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'skip1_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'skip2_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'skip3_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'skip4_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'skip5_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'token_cancelled_at') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'phone_number') {
                                            if (res.data[key]['patient_digsign_willing'] === 'yes') {
                                                res.data[key][dataKey] = 'no';
                                            } else {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key]['phone_number'] : 'no';
                                            }
                                        }
                                    })
                                })                                
                                this.setState((state) => ({ tbody: res.data, totalItemsCount: res.total_items, data: data, loadding: false }));
                                // enable downloadbtn after 2sec
                                setTimeout(function () {
                                This.setState((state) => ({ downloadStatus: 1 }))
                                }, 2000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }

                            }
                        });
                    });


                    // setTimeout(function () {
                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'TAT Report', thead: tableHead, filename: 'Tat-Report.csv', download_btn: true, select2: false, search: false }), () => {
                    //         postService(getTokenTatReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "export": 1,
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             console.log('tat report:', res.data);
                    //             if (res.status) {
                    //                 res.data.map((data, key) => {
                    //                     Object.keys(data).map((dataKey) => {
                    //                         if (dataKey === 'token_issue_date') {
                    //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                    //                         }
                    //                         if (dataKey === 'checkin_time') {
                    //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                    //                         }
                    //                         if (dataKey === 'checkout_time') {
                    //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                    //                         }
                    //                         else {
                    //                             res.data[key][dataKey] = ((res.data[key][dataKey] && res.data[key][dataKey] !== '--') || res.data[key][dataKey] == 0) ? res.data[key][dataKey] : 'NA'
                    //                         }

                    //                     })
                    //                 })
                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false }));
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);



                    break;
                case 'recounselling-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'umr_no',
                            'label': 'Patient UMR'
                        }, {
                            "key": 'ip_no',
                            'label': 'IP No.'
                        },
                        {
                            "key": 'mobile_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'patient_age',
                            'label': 'Patient Age',
                        }, {
                            "key": 'patient_gender',
                            'label': 'Patient Gender'
                        },
                        {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'recounselling_count',
                            'label': 'No of Counselling Done'
                        },
                        {
                            "key": 'date_of_counselling',
                            'label': 'Last Counselling Date'
                        },
                        {
                            "key": 'counsellor_name',
                            'label': 'Last Counselling By'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'Re-Counselling Report', thead: tableHead, filename: 'Recounselling-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                        postService(getRecounsellingReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "export": 0,
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('re-counselling', res);
                            // res.data.map((data, key) => {
                            //     Object.keys(data).map((dataKey) => {
                            //         if (dataKey === 'date_of_counselling') {
                            //             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                            //         }
                            //     })
                            // })
                            if (res.status) {
                                this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                            // enable downloadbtn after 2sec
                            setTimeout(function () {
                                This.setState((state) => ({ downloadStatus: 1 }))
                                }, 2000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });

                    // setTimeout(function () {
                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Re-Counselling Report', thead: tableHead, filename: 'Recounselling-Report.csv', download_btn: true, select2: false, search: false }), () => {
                    //         postService(getRecounsellingReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "export": 1,
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             console.log('re-counselling', res);
                    //             if (res.status) {
                    //                 res.data.map((data, key) => {
                    //                     Object.keys(data).map((dataKey) => {
                    //                         if (dataKey === 'date_of_counselling') {
                    //                             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                         }
                    //                         else {
                    //                             res.data[key][dataKey] = res.data[key][dataKey] ? (res.data[key][dataKey]) : 'NA'
                    //                         }
                    //                     })
                    //                 })

                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false }));
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);


                    break;
                case 'planned-admission-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'patient_umr',
                            'label': 'Patient UMR'
                        },
                        {
                            "key": 'ip_no',
                            'label': 'IP No.'
                        },
                        {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'care_management',
                            'label': 'Care Management'
                        },
                        {
                            "key": 'estimate_type',
                            'label': 'Estimate Type'
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'counselled_date',
                            'label': 'Counselled Date'
                        }, {
                            "key": 'counselled_by',
                            'label': 'Counselled By',
                        }, {
                            "key": 'admitted_date',
                            'label': 'Admission Date'
                        },
                        {
                            "key": 'same_day_admitted',
                            'label': 'Same Day Admission'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'e_date_of_admission',
                            'label':'Estimated Date Of Admission '
                        },
                        {
                            "key": 'remarks',
                            'label':'Remarks '
                        },
                        {
                            "key": 'remarks_category',
                            'label':'Remark Category '
                        },
                        {
                            "key": 'remarks_added_by',
                            'label':'Remarks Added By'
                        },
                        {
                            "key": 'remarks_added_at',
                            'label':'Remarks Added Time '
                        }
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'Planned Admission Report', thead: tableHead, filename: 'Planned-Admission-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                        postService(getPlannedAdmissionsReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "export": 0,//1 for download excel
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('addimission report:', res);
                            if (res.status) {
                                if (res.data && res.data.admissions_data) {
                                    // res.data.admissions_data.map((data, key) => {
                                    //     Object.keys(data).map((dataKey) => {
                                    //         if (dataKey === 'counselled_date') {
                                    //             res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : null
                                    //         }
                                    //         if (dataKey === 'admitted_date') {
                                    //             res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : null
                                    //         }
                                    //     })
                                    // })
                                }
                                this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                            // enable downloadbtn after 2sec
                            setTimeout(function () {
                                This.setState((state) => ({ downloadStatus: 1 }))
                                }, 2000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });

                    // setTimeout(function () {
                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Planned Admission Report', thead: tableHead, filename: 'Planned-Admission-Report.csv', download_btn: true, select2: false, search: false }), () => {
                    //         postService(getPlannedAdmissionsReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "export": 1,//1 for download excel
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             if (res.status) {
                    //                 if (res.data && res.data.admissions_data) {
                    //                     res.data.admissions_data.map((data, key) => {
                    //                         Object.keys(data).map((dataKey) => {
                    //                             if (dataKey === 'counselled_date') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             if (dataKey === 'admitted_date') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             else {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                    //                             }
                    //                         })
                    //                     })
                    //                 }
                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);
                    break;
                case 'estimate-variance-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'patient_ip_number',
                            'label': 'Patient IP Number'
                        },
                        {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": 'discharge_date',
                            'label': 'Discharge Date'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type',
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'care_management',
                            'label': 'Care Management'
                        },
                        {
                            "key": 'estimate_type',
                            'label': 'Estimate Type'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        // {
                        //     "key": 'initial_counselled_amount',
                        //     'label': 'Sai'
                        // },
                        // {
                        //     "key": 'initial_counselled_amount',
                        //     'label': 'Initial Counselled Amount (Rs.)'
                        // },
                        {
                            "key": 'final_counselled_by',
                            'label': 'Final Counselled By'
                        },
                        {
                            "key": 'final_estimate_date',
                            'label': 'Final Estimate Date'
                        },
                        {
                            "key": 'final_counselled_amount',
                            'label': 'Final Counselled Amount (Rs.)'
                        },
                        {
                            "key": 'final_bill',
                            'label': 'Final Bill (Rs.)'
                        },
                        {
                            "key": 'variance_amount',
                            'label': 'Variance (Rs.)'
                        },
                        {
                            "key": 'variance_percent',
                            'label': 'Variance (%)'
                        },
                        {
                            "key": 'variance_percent_range',
                            'label': 'Variance % Range'
                        },
                        {
                            "key": 'positive_variance',
                            'label': 'Positive Variance'
                        },
                        {
                            "key": 'negative_variance',
                            'label': 'Negative Variance'
                        },
                        {
                            "key": 'fc_nme_amt',
                            'label': 'FC NME Amount (Rs.)'
                        },
                        {
                            "key": 'hims_nme_value',
                            'label': 'HIMS NME Amount (Rs.)'
                        },
                        {
                            "key": 'NMEvariance',
                            'label': 'NME Variance (Rs.)'
                        },
                        {
                            "key": 'NMEvariancePercent',
                            'label': 'NME Variance (%)'
                        },
                        {
                            "key": 'NMEpositiveVariance',
                            'label': 'NME Positive Variance'
                        },
                        {
                            "key": 'NMEnegativeVariance',
                            'label': 'NME Negative Variance'
                        },
                        {
                            "key": 'co_pay_amt',
                            'label': 'FC Co-Pay Amount (Rs.)'
                        },
                        {
                            "key": 'hims_copay_amt',
                            'label': 'HIMS Co-Pay Amount (Rs.)'
                        },
                        {
                            "key": 'copay_variance',
                            'label': 'Co-Pay Variance (Rs.)'
                        },
                        {
                            "key": 'copay_variance_percent',
                            'label': 'Co-Pay Variance (%)'
                        },
                        {
                            "key": 'copay_positive_variance',
                            'label': 'Co-Pay Positive Variance'
                        },
                        {
                            "key": 'copay_negative_variance',
                            'label': 'Co-Pay Negative Variance'
                        },
                        {
                            "key": 'difference_type',
                            'label': 'Difference Type'
                        },
                        {
                            "key": 'fc_difference_amt',
                            'label': 'FC Difference Amount (Rs.)'
                        },
                        {
                            "key": 'hims_difference_amt',
                            'label': 'HIMS Difference Amount (Rs.)'
                        },
                        {
                            "key": 'diff_amt_variance',
                            'label': 'Difference Variance (Rs.)'
                        },
                        {
                            "key": 'diff_amt_variance_percent',
                            'label': 'Difference Variance (%)'
                        },
                        {
                            "key": 'diff_amt_positive_variance',
                            'label': 'Difference Positive Variance'
                        },
                        {
                            "key": 'diff_amt_negative_variance',
                            'label': 'Difference Negative Variance'
                        },
                        {
                            "key": 'doctor_tagged_fc',
                            'label': 'Doctor Tagged Status'
                        },
                        {
                            "key": 'icu_tagged_fc',
                            'label': 'ICU Tagged Status'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'is_package',
                            'label': 'IS PACKAGE'
                        },
                        {
                            "key": 'initial_counselled_by',
                            'label': 'Initial Counselled By'
                        },
                        {
                            "key": 'initial_estimate_date',
                            'label': 'Initial Estimate Date'
                        },
                        {
                            "key": 'initial_estimated_amount',
                            'label': 'Initial Esitmate Amount'
                        },
                        {
                            "key": 'estimates_count',
                            'label': 'Count of Estimates'
                        },
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'Estimate Variance Report', thead: tableHead, filename: 'Estimate-Variance-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                        postService(getEstimateVarianceReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "consultant_id": this.state.doctor_id,
                                "payer_type": this.state.payment_type,
                                "export": 0,//1 for download excel
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('addimission report:', res);
                            var data = {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "consultant_id": this.state.doctor_id,
                                "payer_type": this.state.payment_type,
                                "export": 0,//1 for download excel
                                "page_no": isDatefilter ? 1 : activePage
                            }
                            console.log('data', data)
                            if (res.status) {

                                this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                            // enable downloadbtn after 2sec
                            setTimeout(function () {
                                This.setState((state) => ({ downloadStatus: 1 }))
                                }, 5000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });


                    // setTimeout(function () {

                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Estimate Variance Report', thead: tableHead, filename: 'Estimate-Variance-Report.csv', download_btn: true, select2: false, search: false }), () => {
                    //         postService(getEstimateVarianceReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "consultant_id": This.state.doctor_id,
                    //                 "payer_type": This.state.payment_type,
                    //                 "export": 1,//1 for download excel
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             console.log('addimission report:', res);
                    //             var data = {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "consultant_id": This.state.doctor_id,
                    //                 "payer_type": This.state.payment_type,
                    //                 "export": 1,//1 for download excel
                    //                 "page_no": 0
                    //             }
                    //             console.log('data', data)
                    //             if (res.status) {
                    //                 if (res.data && res.data.admissions_data) {
                    //                     res.data.admissions_data.map((data, key) => {
                    //                         Object.keys(data).map((dataKey) => {
                    //                             if (dataKey === 'discharge_date') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             else {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                    //                             }
                    //                         })
                    //                     })
                    //                 }
                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);
                    break;
                case 'idle-reports':
                    tableHead = [
                        {
                            "key": 'date',
                            'label': 'Date'
                        }, {
                            "key": 'counsellor_name',
                            'label': 'Counsellor Name'
                        }, {
                            "key": 'idle_start_time',
                            'label': 'Idle Start Time'
                        }, {
                            "key": 'idle_end_time',
                            'label': 'Idle End Time',
                        }, {
                            "key": 'difference',
                            'label': 'Idle Difference (Min)'
                        },
                        {
                            "key": 'extended_time',
                            'label': 'Extended Time'
                        },
                        {
                            "key": 'reason',
                            'label': 'Idle Reason'
                        }, 
                        {
                            "key": 'counselling_station_name',
                            'label': 'Counselling Station'
                        },
                        {
                            "key": 'break_status',
                            'label': 'Break Type'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        }
                        
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'Idle TAT Report', thead: tableHead, filename: 'Idle-Tat-Report.csv', loadding: true, download_btn: true, select2: false, search: true }), () => {
                        postService(getIdleTatReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "search_key": this.state.searchwords ? this.state.searchwords : "",
                                "export": 0,
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('getIdleTatReport report:', res);
                            if (res.status) {
                                // res.data.admissions_data.map((data, key) => {
                                //     Object.keys(data).map((dataKey) => {
                                //         if (dataKey === 'date') {
                                //             res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                //         }

                                //     })
                                // })
                                this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                // enable downloadbtn after 2sec
                                setTimeout(function () {
                                    This.setState((state) => ({ downloadStatus: 1 }))
                                    }, 2000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });

                    // setTimeout(function () {
                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Idle TAT Report', thead: tableHead, filename: 'Idle-Tat-Report.csv', download_btn: true, select2: false, search: true }), () => {
                    //         postService(getIdleTatReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "search_key": This.state.searchwords ? This.state.searchwords : "",
                    //                 "export": 1,
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             console.log('getIdleTatReport report:', res);
                    //             if (res.status) {
                    //                 if (res.data && res.data.admissions_data) {
                    //                     res.data.admissions_data.map((data, key) => {
                    //                         Object.keys(data).map((dataKey) => {
                    //                             if (dataKey === 'date') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                    //                             }
                    //                             if (dataKey === 'idle_start_time') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                    //                             }
                    //                             if (dataKey === 'idle_end_time') {
                    //                                 res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                    //                             }
                    //                             else {
                    //                                 res.data.admissions_data[key][dataKey] = ((res.data.admissions_data[key][dataKey] && res.data.admissions_data[key][dataKey] !== '-') || res.data.admissions_data[key][dataKey] == 0) ? res.data.admissions_data[key][dataKey] : 'NA'
                    //                             }

                    //                         })
                    //                     })
                    //                 }
                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));

                    //                 console.log('headers:', data)
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);
                    break;
                case 'log-report':
                    tableHead = [
                        {
                            "key": 'user_name',
                            'label': 'Counsellor Name'
                        }, {
                            "key": 'log_date',
                            'label': 'Date'
                        }, 
                        
                        {
                            "key": 'login_time',
                            'label': 'Login Time',
                        }, 
                       
                        {
                            "key": 'logout_time',
                            'label': 'logout Time'
                        },
                        {
                            "key": 'login_logout',
                            'label': 'total Duration'
                        },
                        {
                            "key": 'total_of_break',
                            'label': 'Total of Break'
                        }
                        
                    ];
                 
                        this.setState((state) => ({ showFilter: true, tableTitle: 'Log Report',thead:tableHead, filename: 'Log-Report.csv', loadding: true, download_btn: true, select2: false, search: true }), () => {
                            postService(getLogReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                    "search_key": this.state.searchwords ? this.state.searchwords : "",
                                    "export": 0,
                                    "page_no": isDatefilter ? 1 : activePage
                                }
                            }).then( res =>  {
                                console.log('getLogReport report:', res);
                                if (res.status) {
                                    const data=res.data.admissions_data; 
                                    console.log('data',data);
                                    let breakTotalnumber=0;
                                    let brakStatus=true;
                                    if(data&&data.length>0){
                                       breakTotalnumber =  Math.max(...data.map(o => o.total_break));
                                    }
                                let keys
                                let tableHeads=[];
                                if(data&&data.length>0){
                                    data.map((obj, key) => {
                                        if(obj.total_break===breakTotalnumber&&breakTotalnumber!==0 && brakStatus){
                                           Object.keys(obj).map((dataKey) =>{
                                            if(dataKey!=='total_break'){
                                                if(dataKey==='total_duration'|| dataKey==='total_of_break'){
                                                    tableHeads.push({
                                                        "key": dataKey,
                                                        'label': dataKey+' (HH:MM)'
                                                    })
                                                }else{
                                                    tableHeads.push({
                                                        "key": dataKey,
                                                        'label': dataKey
                                                    })
                                                }
                                                    
                                            }
                                           
                                            })
                                            brakStatus=false
                                        }
                                        if(key==0 && obj.total_break==0 && breakTotalnumber===0){
                                            Object.keys(obj).map((dataKey) =>{
                                                if(dataKey!=='total_break'){
                                                        tableHeads.push({
                                                            "key": dataKey,
                                                            'label': dataKey
                                                        })
                                                }
                                                })
                                                brakStatus=false
                                        }
                                     }); 
                                }else{
                                    tableHeads = [
                                        {
                                            "key": 'user_name',
                                            'label': 'Counsellor Name'
                                        }, {
                                            "key": 'log_date',
                                            'label': 'Date'
                                        }, 
                                        
                                        {
                                            "key": 'login_time',
                                            'label': 'Login Time',
                                        }, 
                                       
                                        {
                                            "key": 'logout_time',
                                            'label': 'logout Time'
                                        },
                                        {
                                            "key": 'login_logout',
                                            'label': 'total Duration(HH:MM)'
                                        },
                                        {
                                            "key": 'total_of_break',
                                            'label': 'Total of Break (HH:MM)'
                                        }
                                    ];
                                }
                                 

                                //  let obj=this.respoenObj(breakTotalnumber);
                                    this.setState((state) => ({ totalItemsCount: res.total_items, tbody:res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false,thead: tableHeads}));
                                    // enable downloadbtn after 2sec
                                    setTimeout(function () {
                                        This.setState((state) => ({ downloadStatus: 1 ,thead: tableHeads}))
                                        }, 2000);
                                } else {
                                    if (res === 401) {
    
                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                        break;
                case 'bill-tat-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'ip_number',
                            'label': 'Patient IP'
                        }, {
                            "key": 'umr_number',
                            'label': 'Patient UMR'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number',
                        }, {
                            "key": 'admission_date',
                            'label': 'Date of Admission'
                        }, {
                            "key": 'discharge_date',
                            'label': 'Discharge date'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        }, {
                            "key": 'department_name',
                            'label': 'Department'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor'
                        }, {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'previous_estimate_fc',
                            'label': 'Previous Estimate FC name'
                        }, {
                            "key": 'previous_estimate',
                            'label': 'Previous Estimate Amount'
                        },
                        {
                            "key": 'previous_estimate_time',
                            'label': 'Previous Counselling Date & Time'
                        },
                        {
                            "key": 'eighty_percent_reached_time',
                            'label': 'Estimated amount reached time'
                        },

                        {
                            "key": 'recounselled_by',
                            'label': 'Recounselling By'
                        }, {
                            "key": 'recounselling_time',
                            'label': 'Recounselling done time'
                        },{
                            "key": 'recounselling_amount',
                            'label': 'Recounselling Amount'
                        },{
                            "key": 'recounselling_privilege',
                            'label': 'Recounselling Privilege'
                        }, {
                            "key": 'tat',
                            'label': 'TAT (Min)'
                        }, {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'trackbills_flag_status',
                            'label': 'Trigger  Status'
                        }
                        // ,
                        // {
                        //     "key": 'recounselling_status',
                        //     'label': 'recounselled status'
                        // }
                    ]

                    this.setState((state) => ({ showFilter: true, tableTitle: 'Bill TAT Report', thead: tableHead, filename: 'Bill-TAT-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                        postService(getBillTrackingTatReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "search_key": this.state.searchwords ? this.state.searchwords : "",
                                "export": 0,
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('getIdleTatReport report:', res);
                            if (res.status) {
                                if (res.data && res.data.admissions_data) {
                                    res.data.admissions_data.map((data, key) => {
                                        Object.keys(data).map((dataKey) => {
                                            if (dataKey === 'admission_date' || dataKey === 'recounselling_time') {
                                                res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                            }
                                            if (dataKey === 'eighty_percent_reached_time') {
                                                res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                            }
                                            if (dataKey === 'previous_estimate_time') {
                                                res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                            }
                                        })
                                    })
                                }

                                this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                // enable downloadbtn after 2sec
                                setTimeout(function () {
                                    This.setState((state) => ({ downloadStatus: 1 }))
                                    }, 2000);
                                console.log('headers:', data)
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });


                    // setTimeout(function () {
                    //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Bill TAT Report', thead: tableHead, filename: 'Bill-TAT-Report.csv', download_btn: true, select2: false, search: false }), () => {
                    //         postService(getBillTrackingTatReport, 'POST', {
                    //             "data": {
                    //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                    //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                    //                 "search_key": This.state.searchwords ? This.state.searchwords : "",
                    //                 "export": 1,
                    //                 "page_no": 0
                    //             }
                    //         }).then(res => {
                    //             console.log('billTatReport report:', res);
                    //             if (res.status) {
                    //                 if (res.data) {
                    //                     res.data.map((data, key) => {
                    //                         Object.keys(data).map((dataKey) => {
                    //                             if (dataKey === 'admission_date' || dataKey === 'recounselling_time' || dataKey === 'discharge_date') {
                    //                                 res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             if (dataKey === 'eighty_percent_reached_time') {
                    //                                 res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             if (dataKey === 'previous_estimate_time') {
                    //                                 res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                    //                             }
                    //                             else {
                    //                                 res.data[key][dataKey] = (res.data[key][dataKey] && res.data[key][dataKey] !== '--') ? res.data[key][dataKey] : 'NA'
                    //                             }
                    //                         })
                    //                     })
                    //                 }

                    //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data ? res.data : [], loadding: false }));

                    //                 console.log('headers:', data)
                    //             } else {
                    //                 if (res === 401) {

                    //                 } else {
                    //                     Modal.error({
                    //                         title: 'Failure',
                    //                         content: "Oops! something went wrong... Please try again.",
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     });
                    // }, 3000);
                    break;
                case 'remarks-report':
                tableHead = [
                    {
                        "key": 'patient_name',
                        'label': 'Patient Name'
                    }, {
                        "key": 'ip_no',
                        'label': 'Patient IP'
                    }, {
                        "key": 'umr_no',
                        'label': 'Patient UMR'
                    },
                    //  {
                    //     "key": 'phone_number',
                    //     'label': 'Phone Number',
                    // },
                    //  {
                    //     "key": 'admission_date',
                    //     'label': 'Date of Admission'
                    // // }, {
                    //     "key": 'discharge_date',
                    //     'label': 'Discharge date'
                    // }, {
                    //     "key": 'payer_type',
                    //     'label': 'Payer Type'
                    // }, {
                    //     "key": 'department_name',
                    //     'label': 'Department'
                    // }, {
                    //     "key": 'doctor_name',
                    //     'label': 'Doctor'
                    // }, {
                    //     "key": 'procedure_name',
                    //     'label': 'Procedure Name'
                    // },
                    // {
                    //     "key": 'privilege_name',
                    //     'label': 'Privilege Name'
                    // },
                    // {
                    //     "key": 'previous_estimate_fc',
                    //     'label': 'Previous Estimate FC name'
                    // }, {
                    //     "key": 'previous_estimate',
                    //     'label': 'Previous Estimate Amount'
                    // },
                    // {
                    //     "key": 'previous_estimate_time',
                    //     'label': 'Previous Counselling Date & Time'
                    // },
                    // {
                    //     "key": 'eighty_percent_reached_time',
                    //     'label': 'Estimated amount reached time'
                    // },

                    // {
                    //     "key": 'recounselled_by',
                    //     'label': 'Recounselling By'
                    // }, {
                    //     "key": 'recounselling_time',
                    //     'label': 'Recounselling done time'
                    // },{
                    //     "key": 'recounselling_amount',
                    //     'label': 'Recounselling Amount'
                    // },{
                    //     "key": 'recounselling_privilege',
                    //     'label': 'Recounselling Privilege'
                    // }, {
                    //     "key": 'tat',
                    //     'label': 'TAT (Min)'
                    // },
                    {
                        "key": 'remarks',
                        'label': 'Remarks'
                    },
                    {
                        "key": 'remarks_from',
                        'label': 'Remarks From'
                    },
                    {
                        "key": 'created_by',
                        'label': 'Created By'
                    },
                    {
                        "key": 'created_at',
                        'label': 'Created At'
                    },
                     {
                        "key": 'category_name',
                        'label': 'Category'
                    },
                    {
                        "key": 'call_log_reason',
                        'label': 'Reason'
                    },
                    {
                        "key": 'call_log_eda',
                        'label': 'Requested EDA'
                    },
                    {
                        "key": 'call_log_surgery_date',
                        'label': 'Date of Surgery'
                    },
                    {
                        "key": 'call_back_date',
                        'label': 'Call Back Date'
                    },
                    {
                        "key": 'doctor_tagged_status',
                        'label': 'Doctor Tagged Status'
                    },
                    {
                        "key": 'icu_tagged_status',
                        'label': 'ICU Tagged Status'
                    },

                    // ,
                    // {
                    //     "key": 'recounselling_status',
                    //     'label': 'recounselled status'
                    // }
                ]
                this.setState((state) => ({ showFilter: true, tableTitle: 'Remarks Report', thead: tableHead, filename: 'Remarks Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                    postService(getRemarksReport, 'POST', {
                        "data": {
                            "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                            "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                            "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                            "export": 0,
                            "page_no": isDatefilter ? 1 : activePage
                        }
                    }).then(res => {
                        console.log('getIdleTatReport report:', res);
                        if (res.status) {
                            if (res.data && res.data.admissions_data) {
                                res.data.admissions_data.map((data, key) => {
                                    Object.keys(data).map((dataKey) => {
                                        if (dataKey === 'admission_date' || dataKey === 'recounselling_time') {
                                            res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                        }
                                        if (dataKey === 'eighty_percent_reached_time') {
                                            res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                        }
                                        if (dataKey === 'previous_estimate_time') {
                                            res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                        }
                                    })
                                })
                            }

                            this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                            // enable downloadbtn after 2sec
                            setTimeout(function () {
                                This.setState((state) => ({ downloadStatus: 1 }))
                                }, 2000);
                            console.log('headers:', data)
                        } else {
                            if (res === 401) {

                            } else {
                                Modal.error({
                                    title: 'Failure',
                                    content: "Oops! something went wrong... Please try again.",
                                });
                            }
                        }
                    });
                });
                break;
            default: 
                break; 
            }
        } catch (error) {
            console.log(error);
        }
    }
    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        // console.log('formFeilds:',formFeilds[2].value)
        // console.log('formFeilds 1:',formFeilds[1].value)
        this.setState(({
            activePage: 1,
            totalItemsCount: 0, doctor_id: formFeilds[0].value, payment_type: parseInt(formFeilds[1].value), searchwords: formFeilds[2].value
        }), () => {
            this.loadPage()
        })
        // if (ele) {
        //     this
        //         .state
        //         .formData
        //         .map((data, key) => {

        //         });
        // }
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            tbody: [],
            activePage: page,
        }), () => {
            this.loadPage();
        })
    }
    search = () => {
        // let {search}=this.state
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage();
        })
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })        
    }
    downloadFile = (isDatefilter = false) => {
        try {
            let { activePage, search_key } = this.state;
            let { slug } = this.props.match.params;
            const { getTokenTatReport, getRecounsellingReport, getPlannedAdmissionsReport, getEstimateVarianceReport, getIdleTatReport, getBillTrackingTatReport ,getRemarksReport,getLogReport} = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            // let data = {
            //     "from": this.state.dateFrom,
            //     "to": this.state.dateTo
            // }
            console.log('slug:', slug)
            switch (slug) {
                case 'tat-reports':
                    tableHead = [
                        {
                            "key": 'token_number',
                            'label': 'Token Number'
                        }, {
                            "key": 'token_issue_date',
                            'label': 'Token Issue Date'
                        },
                        {
                            "key": 'ip',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        
                        {
                            "key": 'served_privilege_name',
                            'label': 'Privilege Served'
                        },
                        {
                            "key": 'counsellor_name',
                            'label': 'Counsellor Name'
                        },
                        {
                            "key": 'token_assigned_time',
                            'label': 'Token Assigned Time'
                        }, {
                            "key": 'checkin_time',
                            'label': 'Check In Time',
                        }, {
                            "key": 'checkout_time',
                            'label': 'Check Out Time'
                        },
                        {
                            "key": 'tat1',
                            'label': 'TAT 1 Waiting Time (Min)'
                        },
                        {
                            "key": 'tat2',
                            'label': 'TAT 2 Transaction Time (Min)'
                        },
                        {
                            "key": 'skip_status',
                            'label': 'Token Skip'
                        },
                        {
                            "key": 'token_status',
                            'label': 'Token Cancelled'
                        },
                        {
                            "key": 'token_cancelled_by',
                            'label': 'Token Cancelled By'
                        },
                        {
                            "key": 'token_cancelled_at',
                            'label': 'Token Cancelled At'
                        },
                        {
                            "key": 'doctor_tagged_fc',
                            'label': 'Doctor Tagged Status'
                        },
                        {
                            "key": 'icu_tagged_fc',
                            'label': 'ICU Tagged Status'
                        },
                        {
                            "key": 'counselling_station_name',
                            'label': 'Counselling Station'
                        },
                        {
                            "key": 'token_generated_by',
                            'label': 'Token generated by'
                        }, 
                        {
                            "key": 'skip1_time',
                            'label': 'Skip1 Time'
                        }, 
                        {
                            "key": 'skip1_done_by',
                            'label': 'Skip1 Done By '
                        },
                        {
                            "key": 'skip2_time',
                            'label': 'Skip2 Time'
                        }, 
                        {
                            "key": 'skip2_done_by',
                            'label': 'Skip2 Done By '
                        }, 
                        {
                            "key": 'skip3_time',
                            'label': 'Skip3 Time'
                        }, 
                        {
                            "key": 'skip3_done_by',
                            'label': 'Skip3 Done By '
                        },
                        {
                            "key": 'skip4_time',
                            'label': 'Skip4 Time'
                        }, 
                        {
                            "key": 'skip4_done_by',
                            'label': 'Skip4 Done By '
                        },
                        {
                            "key": 'skip5_time',
                            'label': 'Skip5 Time'
                        }, 
                        {
                            "key": 'skip5_done_by',
                            'label': 'Skip5 Done By '
                        },{
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'digital_sig_weblink',
                            'label': 'SMS OTP sent'
                        },
                        {
                            "key": 'phone_number',
                            'label': 'SMS OTP sent mobile number'
                        },
                        {
                            "key": 'digital_sig_weblink',
                            'label': 'OTP Varified'
                        },
                        {
                            "key": 'patient_digsign_willing',
                            'label': 'patient unavailable/ unwilling check box marked'
                        }
                    ]
                        This.setState((state) => ({ thead: tableHead, filename: 'Tat-Report.csv', download_btn: true, downloadStatus: 0, loadding: true }), () => {
                            postService(getTokenTatReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "export": 1,
                                    "search_key":search_key,
                                    "page_no": 0
                                }
                            }).then(res => {
                                console.log('tat report:', res.data);
                                if (res.status) {
                                    res.data.map((data, key) => {
                                        Object.keys(data).map((dataKey) => {
                                            if (dataKey === 'token_issue_date') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                                            }
                                            if (dataKey === 'checkin_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                                            }
                                            if (dataKey === 'checkout_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                                            }
                                            if (dataKey === 'skip1_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                            }
                                            if (dataKey === 'skip2_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                            }
                                            if (dataKey === 'skip3_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                            }
                                            if (dataKey === 'skip4_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                            }
                                            if (dataKey === 'skip5_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey]!=="" ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                            }
                                            if (dataKey === 'token_assigned_time') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                                            }
                                            if (dataKey === 'token_cancelled_at') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT').toString() : 'NA'
                                            }
                                            else {
                                                res.data[key][dataKey] = ((res.data[key][dataKey] && res.data[key][dataKey] !== '--') || (res.data[key][dataKey] == 0) && (res.data[key][dataKey]!==''))  ? res.data[key][dataKey] : 'NA'
                                            }

                                        })
                                    })
                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false, }));
                                    this.csvLink.current.link.click()
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'recounselling-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'umr_no',
                            'label': 'Patient UMR'
                        }, {
                            "key": 'ip_no',
                            'label': 'IP No.'
                        },
                        {
                            "key": 'mobile_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'patient_age',
                            'label': 'Patient Age',
                        }, {
                            "key": 'patient_gender',
                            'label': 'Patient Gender'
                        },
                        {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'recounselling_count',
                            'label': 'No of Counselling Done'
                        },
                        {
                            "key": 'date_of_counselling',
                            'label': 'Last Counselling Date'
                        },
                        {
                            "key": 'counsellor_name',
                            'label': 'Last Counselling By'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        }
                    ]
                        This.setState((state) => ({ thead: tableHead, filename: 'Recounselling-Report.csv', download_btn: true, downloadStatus: 0, loadding: true }), () => {
                            postService(getRecounsellingReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "export": 1,
                                    "page_no": 0
                                }
                            }).then(res => {
                                console.log('re-counselling', res);
                                if (res.status) {
                                    res.data.map((data, key) => {
                                        Object.keys(data).map((dataKey) => {
                                            if (dataKey === 'date_of_counselling') {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                            }
                                            else {
                                                res.data[key][dataKey] = res.data[key][dataKey] ? (res.data[key][dataKey]) : 'NA'
                                            }
                                        })
                                    })

                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false }));
                                    this.csvLink.current.link.click()
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'planned-admission-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'patient_umr',
                            'label': 'Patient UMR'
                        },
                        {
                            "key": 'ip_no',
                            'label': 'IP No.'
                        },
                        {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'care_management',
                            'label': 'Care Management'
                        },
                        {
                            "key": 'estimate_type',
                            'label': 'Estimate Type'
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        },
                        {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'counselled_date',
                            'label': 'Counselled Date'
                        }, {
                            "key": 'counselled_by',
                            'label': 'Counselled By',
                        }, {
                            "key": 'admitted_date',
                            'label': 'Admission Date'
                        },
                        {
                            "key": 'same_day_admitted',
                            'label': 'Same Day Admission'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'e_date_of_admission',
                            'label':'Estimated Date Of Admission '
                        },
                        {
                            "key": 'remarks',
                            'label':'Remarks '
                        },
                        {
                            "key": 'remarks_category',
                            'label':'Remark Category '
                        },
                        {
                            "key": 'remarks_added_by',
                            'label':'Remarks Added By'
                        },
                        {
                            "key": 'remarks_added_at',
                            'label':'Remarks Added Time '
                        }
                    ]
                        This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Planned-Admission-Report.csv', download_btn: true, loadding: true }), () => {
                            postService(getPlannedAdmissionsReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "export": 1,//1 for download excel
                                    "page_no": 0
                                }
                            }).then(res => {
                                if (res.status) {
                                    if (res.data && res.data.admissions_data) {
                                        res.data.admissions_data.map((data, key) => {
                                            Object.keys(data).map((dataKey) => {
                                                if (dataKey === 'counselled_date') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                }
                                                if (dataKey === 'admitted_date') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                }
                                                if(dataKey === 'e_date_of_admission') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY').toString() : 'NA'
                                                }
                                                else {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                                                }
                                            })
                                        })
                                    }
                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                    this.csvLink.current.link.click();
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'estimate-variance-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'patient_ip_number',
                            'label': 'Patient IP Number'
                        },
                        {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": 'discharge_date',
                            'label': 'Discharge Date'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type',
                        },
                        {
                            "key": 'department_name',
                            'label': 'Department Name'
                        },
                        {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'privilege_name',
                            'label': 'Privilege Name'
                        },
                        {
                            "key": 'care_management',
                            'label': 'Care Management'
                        },
                        {
                            "key": 'estimate_type',
                            'label': 'Estimate Type'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        // {
                        //     "key": 'initial_counselled_amount',
                        //     'label': 'Initial Counselled Amount (Rs.)'
                        // },
                        {
                            "key": 'final_counselled_by',
                            'label': 'Final Counselled By'
                        },
                        {
                            "key": 'final_estimate_date',
                            'label': 'Final Estimate Date'
                        },
                        {
                            "key": 'final_counselled_amount',
                            'label': 'Final Counselled Amount (Rs.)'
                        },
                        {
                            "key": 'final_bill',
                            'label': 'Final Bill (Rs.)'
                        },
                        {
                            "key": 'variance_amount',
                            'label': 'Variance (Rs.)'
                        },
                        {
                            "key": 'variance_percent',
                            'label': 'Variance (%)'
                        },
                        {
                            "key": 'variance_percent_range',
                            'label': 'Variance % Range'
                        },
                        {
                            "key": 'positive_variance',
                            'label': 'Positive Variance'
                        },
                        {
                            "key": 'negative_variance',
                            'label': 'Negative Variance'
                        },
                        {
                            "key": 'fc_nme_amt',
                            'label': 'FC NME Amount (Rs.)'
                        },
                        {
                            "key": 'hims_nme_value',
                            'label': 'HIMS NME Amount (Rs.)'
                        },
                        {
                            "key": 'NMEvariance',
                            'label': 'NME Variance (Rs.)'
                        },
                        {
                            "key": 'NMEvariancePercent',
                            'label': 'NME Variance (%)'
                        },
                        {
                            "key": 'NMEpositiveVariance',
                            'label': 'NME Positive Variance'
                        },
                        {
                            "key": 'NMEnegativeVariance',
                            'label': 'NME Negative Variance'
                        },
                        {
                            "key": 'co_pay_amt',
                            'label': 'FC Co-Pay Amount (Rs.)'
                        },
                        {
                            "key": 'hims_copay_amt',
                            'label': 'HIMS Co-Pay Amount (Rs.)'
                        },
                        {
                            "key": 'copay_variance',
                            'label': 'Co-Pay Variance (Rs.)'
                        },
                        {
                            "key": 'copay_variance_percent',
                            'label': 'Co-Pay Variance (%)'
                        },
                        {
                            "key": 'copay_positive_variance',
                            'label': 'Co-Pay Positive Variance'
                        },
                        {
                            "key": 'copay_negative_variance',
                            'label': 'Co-Pay Negative Variance'
                        },
                        {
                            "key": 'difference_type',
                            'label': 'Difference Type'
                        },
                        {
                            "key": 'fc_difference_amt',
                            'label': 'FC Difference Amount (Rs.)'
                        },
                        {
                            "key": 'hims_difference_amt',
                            'label': 'HIMS Difference Amount (Rs.)'
                        },
                        {
                            "key": 'diff_amt_variance',
                            'label': 'Difference Variance (Rs.)'
                        },
                        {
                            "key": 'diff_amt_variance_percent',
                            'label': 'Difference Variance (%)'
                        },
                        {
                            "key": 'diff_amt_positive_variance',
                            'label': 'Difference Positive Variance'
                        },
                        {
                            "key": 'diff_amt_negative_variance',
                            'label': 'Difference Negative Variance'
                        },
                        {
                            "key": 'doctor_tagged_fc',
                            'label': 'Doctor Tagged Status'
                        },
                        {
                            "key": 'icu_tagged_fc',
                            'label': 'ICU Tagged Status'
                        },
                        {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'is_package',
                            'label': 'IS PACKAGE'
                        },
                        {
                            "key": 'initial_counselled_by',
                            'label': 'Initial Counselled By'
                        },
                        {
                            "key": 'initial_estimate_date',
                            'label': 'Initial Estimate Date'
                        },
                        {
                            "key": 'initial_estimated_amount',
                            'label': 'Initial Esitmate Amount'
                        },
                        {
                            "key": 'estimates_count',
                            'label': 'Count of Estimates'
                        },
                    ]
                        This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Estimate-Variance-Report.csv', download_btn: true, loadding: true }), () => {
                            postService(getEstimateVarianceReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "consultant_id": This.state.doctor_id,
                                    "payer_type": This.state.payment_type,
                                    "export": 1,//1 for download excel
                                    "page_no": 0
                                }
                            }).then(res => {
                                console.log('addimission report:', res);
                                var data = {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "consultant_id": This.state.doctor_id,
                                    "payer_type": This.state.payment_type,
                                    "export": 1,//1 for download excel
                                    "page_no": 0
                                }
                                console.log('data', data)
                                if (res.status) {
                                    if (res.data && res.data.admissions_data) {
                                        res.data.admissions_data.map((data, key) => {
                                            Object.keys(data).map((dataKey) => {
                                                if (dataKey === 'discharge_date') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                } else if (dataKey === 'final_estimate_date'){
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                } else {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                                                }
                                            })
                                        })
                                    }
                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                    this.csvLink.current.link.click();
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'idle-reports':
                    tableHead = [
                        {
                            "key": 'date',
                            'label': 'Date'
                        }, {
                            "key": 'counsellor_name',
                            'label': 'Counsellor Name'
                        }, {
                            "key": 'idle_start_time',
                            'label': 'Idle Start Time'
                        }, {
                            "key": 'idle_end_time',
                            'label': 'Idle End Time',
                        }, {
                            "key": 'difference',
                            'label': 'Idle Difference (Min)'
                        },{
                            "key": 'extended_time',
                            'label': 'Extended Time'
                        },
                        {
                            "key": 'reason',
                            'label': 'Idle Reason'
                        }, {
                            "key": 'counselling_station_name',
                            'label': 'Counselling Station'
                        },
                        {
                            "key": 'break_status',
                            'label': 'Break Type'
                        },
                         {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        // {
                        //     "key": 'trackbills_flag_status',
                        //     'label': 'Trigger Status'
                        // }
                    ]
                        This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Idle-Tat-Report.csv', download_btn: true, loadding: true}), () => {
                            postService(getIdleTatReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "search_key": This.state.searchwords ? This.state.searchwords : "",
                                    "export": 1,
                                    "page_no": 0
                                }
                            }).then(res => {
                                console.log('getIdleTatReport report:', res);
                                if (res.status) {
                                    if (res.data && res.data.admissions_data) {
                                        res.data.admissions_data.map((data, key) => {
                                            Object.keys(data).map((dataKey) => {
                                                if (dataKey === 'date') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                                }
                                                if (dataKey === 'idle_start_time') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                                }
                                                if (dataKey === 'extended_time') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key]['break_status']==='auto' ?  'NA':res.data.admissions_data[key][dataKey];
                                                }
                                                if (dataKey === 'reason') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key]['break_status']==='auto' ?  'NA':res.data.admissions_data[key][dataKey];
                                                }
                                                if (dataKey === 'idle_end_time') {
                                                    res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? moment(res.data.admissions_data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                                }
                                                else {
                                                    res.data.admissions_data[key][dataKey] = ((res.data.admissions_data[key][dataKey] && res.data.admissions_data[key][dataKey] !== '-') || res.data.admissions_data[key][dataKey] == 0) ? res.data.admissions_data[key][dataKey] : 'NA'
                                                }

                                            })
                                        })
                                    }
                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                    this.csvLink.current.link.click();
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'bill-tat-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'ip_number',
                            'label': 'Patient IP'
                        }, {
                            "key": 'umr_number',
                            'label': 'Patient UMR'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number',
                        }, {
                            "key": 'admission_date',
                            'label': 'Date of Admission'
                        }, {
                            "key": 'discharge_date',
                            'label': 'Discharge date'
                        }, {
                            "key": 'payer_type',
                            'label': 'Payer Type'
                        }, {
                            "key": 'department_name',
                            'label': 'Department'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor'
                        }, {
                            "key": 'procedure_name',
                            'label': 'Procedure Name'
                        },
                        {
                            "key": 'ward_name',
                            'label': 'Ward Name'
                        },
                        {
                            "key": 'nurse_station_name',
                            'label': 'Nurse Station Name'
                        },
                        {
                            "key": 'is_iccu',
                            'label': 'Is ICCU'
                        },
                        {
                            "key": 'block',
                            'label': 'Block'
                        },
                        {
                            "key": 'floor',
                            'label': 'Floor '
                        },
                        {
                            "key": 'previous_estimate_fc',
                            'label': 'Previous Estimate FC name'
                        }, {
                            "key": 'previous_estimate',
                            'label': 'Previous Estimate Amount'
                        },
                        {
                            "key": 'previous_estimate_time',
                            'label': 'Previous Counselling Date & Time'
                        },
                        {
                            "key": 'eighty_percent_reached_time',
                            'label': 'Estimated amount reached time'
                        },

                        {
                            "key": 'recounselled_by',
                            'label': 'Recounselling By'
                        }, {
                            "key": 'recounselling_time',
                            'label': 'Recounselling done time'
                        },{
                            "key": 'recounselling_amount',
                            'label': 'Recounselling Amount'
                        },{
                            "key": 'recounselling_privilege',
                            'label': 'Recounselling Privilege'
                        }, {
                            "key": 'tat',
                            'label': 'TAT (Min)'
                        }, {
                            "key": 'unit_name',
                            'label': 'Unit Name'
                        },
                        {
                            "key": 'trackbills_flag_status',
                            'label': 'Trigger Status'
                        }
                     
                    ]
                        This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Bill-TAT-Report.csv', download_btn: true, loadding: true }), () => {
                            postService(getBillTrackingTatReport, 'POST', {
                                "data": {
                                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                    "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                    "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                    "search_key": This.state.searchwords ? This.state.searchwords : "",
                                    "export": 1,
                                    "page_no": 0
                                }
                            }).then(res => {
                                console.log('billTatReport report:', res);
                                if (res.status) {
                                    if (res.data) {
                                        res.data.map((data, key) => {
                                            Object.keys(data).map((dataKey) => {
                                                if (dataKey === 'admission_date' || dataKey === 'recounselling_time' || dataKey === 'discharge_date') {
                                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                }
                                                if (dataKey === 'eighty_percent_reached_time') {
                                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                }
                                                if (dataKey === 'previous_estimate_time') {
                                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                }
                                                else {
                                                    res.data[key][dataKey] = (res.data[key][dataKey] && res.data[key][dataKey] !== '--') ? res.data[key][dataKey] : 'NA'
                                                }
                                            })
                                        })
                                    }

                                    This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data ? res.data : [], loadding: false }));
                                    this.csvLink.current.link.click();
                                } else {
                                    if (res === 401) {

                                    } else {
                                        Modal.error({
                                            title: 'Failure',
                                            content: "Oops! something went wrong... Please try again.",
                                        });
                                    }
                                }
                            });
                        });
                    break;
                case 'remarks-report':
                    tableHead = [
                        {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'ip_no',
                            'label': 'Patient IP'
                        }, {
                            "key": 'umr_no',
                            'label': 'Patient UMR'
                        },
                        //  {
                        //     "key": 'phone_number',
                        //     'label': 'Phone Number',
                        // },
                        //  {
                        //     "key": 'admission_date',
                        //     'label': 'Date of Admission'
                        // // }, {
                        //     "key": 'discharge_date',
                        //     'label': 'Discharge date'
                        // }, {
                        //     "key": 'payer_type',
                        //     'label': 'Payer Type'
                        // }, {
                        //     "key": 'department_name',
                        //     'label': 'Department'
                        // }, {
                        //     "key": 'doctor_name',
                        //     'label': 'Doctor'
                        // }, {
                        //     "key": 'procedure_name',
                        //     'label': 'Procedure Name'
                        // },
                        // {
                        //     "key": 'privilege_name',
                        //     'label': 'Privilege Name'
                        // },
                        // {
                        //     "key": 'previous_estimate_fc',
                        //     'label': 'Previous Estimate FC name'
                        // }, {
                        //     "key": 'previous_estimate',
                        //     'label': 'Previous Estimate Amount'
                        // },
                        // {
                        //     "key": 'previous_estimate_time',
                        //     'label': 'Previous Counselling Date & Time'
                        // },
                        // {
                        //     "key": 'eighty_percent_reached_time',
                        //     'label': 'Estimated amount reached time'
                        // },
    
                        // {
                        //     "key": 'recounselled_by',
                        //     'label': 'Recounselling By'
                        // }, {
                        //     "key": 'recounselling_time',
                        //     'label': 'Recounselling done time'
                        // },{
                        //     "key": 'recounselling_amount',
                        //     'label': 'Recounselling Amount'
                        // },{
                        //     "key": 'recounselling_privilege',
                        //     'label': 'Recounselling Privilege'
                        // }, {
                        //     "key": 'tat',
                        //     'label': 'TAT (Min)'
                        // },
                        {
                            "key": 'remarks',
                            'label': 'Remarks'
                        },
                        {
                            "key": 'remarks_from',
                            'label': 'Remarks From'
                        },
                        {
                            "key": 'created_by',
                            'label': 'Created By'
                        },
                        {
                            "key": 'created_at',
                            'label': 'Created At'
                        },{
                            "key": 'category_name',
                            'label': 'Category'
                        },
                        {
                            "key": 'call_log_reason',
                            'label': 'Reason'
                        },
                        {
                            "key": 'call_log_eda',
                            'label': 'Requested EDA'
                        },
                        {
                            "key": 'call_log_surgery_date',
                            'label': 'Date of Surgery'
                        },
                        {
                            "key": 'call_back_date',
                            'label': 'Call Back Date'
                        },
                        {
                            "key": 'doctor_tagged_status',
                            'label': 'Doctor Tagged Status'
                        },
                        {
                            "key": 'icu_tagged_status',
                            'label': 'ICU Tagged Status'
                        },
                        //  {
                        //     "key": 'unit_id',
                        //     'label': 'Unit Name'
                        // }
                        // ,
                        // {
                        //     "key": 'recounselling_status',
                        //     'label': 'recounselled status'
                        // }
                    ]
                            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Remarks-Report.csv', download_btn: true, loadding: true }), () => {
                                postService(getRemarksReport, 'POST', {
                                    "data": {
                                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                        "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                        "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                        "export": 1,
                                        "page_no": 0
                                    }
                                }).then(res => {
                                    console.log('billTatReport report:', res);
                                    if (res.status) {
                                        if (res.data) {
                                            res.data.map((data, key) => {
                                                Object.keys(data).map((dataKey) => {
                                                    if (dataKey === 'admission_date' || dataKey === 'recounselling_time' || dataKey === 'discharge_date') {
                                                        res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                    }
                                                    if (dataKey === 'eighty_percent_reached_time') {
                                                        res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                    }
                                                    if (dataKey === 'previous_estimate_time') {
                                                        res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                                    }
                                                    else {
                                                        res.data[key][dataKey] = (res.data[key][dataKey] && res.data[key][dataKey] !== '--') ? res.data[key][dataKey] : 'NA'
                                                    }
                                                })
                                            })
                                        }
    
                                        This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data ? res.data : [], loadding: false }));
                                        this.csvLink.current.link.click();
                                    } else {
                                        if (res === 401) {
    
                                        } else {
                                            Modal.error({
                                                title: 'Failure',
                                                content: "Oops! something went wrong... Please try again.",
                                            });
                                        }
                                    }
                                });
                            });
                        break; 
                case 'log-report':
                    tableHead = [
                        {
                            "key": 'user_name',
                            'label': 'Counsellor Name'
                        }, {
                            "key": 'log_date',
                            'label': 'Date'
                        }, 
                        
                        {
                            "key": 'login_time',
                            'label': 'Login Time',
                        }, 
                        {
                            "key": 'break_starttime_0',
                            'label': 'Break 1 Start Time'
                        },
                        {
                            "key": 'break_endtime_0',
                            'label': 'Break 1 End Time'
                        }, {
                            "key": 'break_reson_0',
                            'label': 'Break 1 Reason'
                        },{
                            "key": 'break_starttime_1',
                            'label': 'Break 2 Start Time'
                        },
                        {
                            "key": 'break_endtime_1',
                            'label': 'Break 2 End Time'
                        }, {
                            "key": 'break_reson_1',
                            'label': 'Break 2 Reason'
                        },
                        {
                            "key": 'break_starttime_2',
                            'label': 'Break 3 Start Time'
                        },
                        {
                            "key": 'break_endtime_2',
                            'label': 'Break 3 End Time'
                        }, {
                            "key": 'break_reson_2',
                            'label': 'break 3 reason'
                        },
                        {
                            "key": 'logout_time',
                            'label': 'logout Time'
                        },
                        {
                            "key": 'login_logout',
                            'label': 'total Duration'
                        },
                        {
                            "key": 'total_of_break',
                            'label': 'Total of Break'
                        },
                        
                    ];
                          
                                This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Log-Report.csv', download_btn: true, loadding: true}), () => {
                                    postService(getLogReport, 'POST', {
                                        "data": {
                                            "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                            "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                            "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                            "search_key": This.state.searchwords ? This.state.searchwords : "",
                                            "export": 1,
                                            "page_no": 0
                                        }
                                    }).then(res => {
                                        console.log('getLogReport report:', res);
                                        if (res.status) {
                                            const data=res.data.admissions_data; 
                                            let breakTotalnumber=0
                                            let brakStatus=true;
                                            if(data&&data.length>0){
                                               breakTotalnumber =  Math.max(...data.map(o => o.total_break));
                                            }
                                           let tableHeads=[];
                                           data &&  data.map((obj, key) => {
                                            if(obj.total_break===breakTotalnumber&&breakTotalnumber!==0 && brakStatus){
                                               Object.keys(obj).map((dataKey) =>{
                                                if(dataKey!=='total_break'){
                                                    if(dataKey==='total_duration'|| dataKey==='total_of_break'){
                                                        tableHeads.push({
                                                            "key": dataKey,
                                                            'label': (dataKey+'(HH:MM)').replaceAll("_"," ")
                                                        })  
                                                    }else{
                                                        tableHeads.push({
                                                            "key": dataKey,
                                                            'label': dataKey.replaceAll("_"," ")
                                                        })
                                                    }
                                                       
                                                }
                                                })
                                                brakStatus=false
                                            }
                                            if(key==0 && obj.total_break==0 && breakTotalnumber===0 && brakStatus){
                                                Object.keys(obj).map((dataKey) =>{
                                                    if(dataKey!=='total_break'){
                                                            tableHeads.push({
                                                                "key": dataKey,
                                                                'label': dataKey.replaceAll("_"," ")
                                                            })
                                                    }
                                                    
                                                   
                                                    })
                                                    brakStatus=false
                                            }
                                         });
                                            this.setState((state) => ({ totalItemsCount: res.total_items, tbody:res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false,thead: tableHeads}));
                                            if (res.data && res.data.admissions_data) {
                                                res.data.admissions_data.map((data, key) => {
                                                    Object.keys(data).map((dataKey) => {
                                                            res.data.admissions_data[key][dataKey] = ((res.data.admissions_data[key][dataKey] && res.data.admissions_data[key][dataKey] !== '-') || res.data.admissions_data[key][dataKey] == 0) ? res.data.admissions_data[key][dataKey] : 'NA'
                                                    })
                                                })
                                            }
                                            This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                                            this.csvLink.current.link.click();
                                        } else {
                                            if (res === 401) {
        
                                            } else {
                                                Modal.error({
                                                    title: 'Failure',
                                                    content: "Oops! something went wrong... Please try again.",
                                                });
                                            }
                                        }
                                    });
                                });
                            break;
                default: 
                break;           
            }
        } catch (error) {
            console.log(error);
        }
    }
    searchClick() {
        i = 0;
        this.setState((state) => ({ 'page_data_count': 1, activePage:1 }), () => {
            this.loadPage();
        })
    }
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({ 'search_key': value }), () => {

        });
    }
    render() {
        let { totalItemsCount, formData, downloadtbody, downloadStatus, tableTitle, thead, data, tbody, filename, download_btn, select2, search, activePage, inputSearch } = this.state;
        let { slug } = this.props.match.params;
        return (
            <div>
                <div className="clearfix">
                {
                    download_btn
                        ?
                        downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                               <button className="btn btn-success text-capitalize float-left" onClick={()=>{this.downloadFile()}}>
                                   <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span>
                                </button>
                               <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                {/* <CSVLink data={downloadtbody} headers={thead} filename={filename}>
                                    <button className="btn btn-success text-capitalize float-left"><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /> <span> Download Report</span></button>
                                </CSVLink> */}
                            </div>
                            :
                            <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize float-left" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                            </div>
                        :
                        <div className="mt-5" />
                }
                </div>
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="float-left pt-1">
                                    {tableTitle}
                                </div>
                                <div className="row">
                                    {formData
                                        .map((feild, key) => {
                                            {
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <div className="col-4">
                                                            {
                                                                select2
                                                                    ?
                                                                    <div className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Select2
                                                                            selectdata={feild}
                                                                            // changedObj={this.state.changedObj}
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            // Queuedata={this.state.formData}
                                                                            onselectChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>

                                                    )
                                                }
                                            }
                                            if (feild.element === 'input' && slug!=='log-report') {
                                                return (
                                                    <div className="">
                                                        {
                                                            search
                                                                ?
                                                                <div className="d-flex mx-auto" style={{ 'position': 'absolute', 'left': '370px' }}>
                                                                    <div
                                                                        className={`${feild.className
                                                                            ? feild.className
                                                                            : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Inputlayer
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            feildData={feild}
                                                                            onInputChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                        <div class="input-group-append">
                                                                            {/* <Button type="primary" onClick={this.search} loading={this.state.loadding}><img src="/assets/images/icons/search.png"></img></Button> */}
                                                                            <button class="btn btn-primary btn-sm" onClick={this.search}><img src={homepage+"/assets/images/icons/search.png"} /></button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                )
                                            }
                                            if (feild.element === 'inputSearch' && feild.visible) {
                                                return (
                                                    <div>
                                                        {inputSearch ? 
                                                            <div className="col-16 mx-auto" style={{marginRight:'200px'}}>
                                                                <div class="input-group">
                                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" style={{marginLeft: '100px', marginTop: '-30px', minWidth:'250px'}} placeholder={feild.placeholder} onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                                    <div class="input-group-append" style={{marginTop: '-30px'}}>
                                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                    </div>
                                                                </div>
                                                            </div>:null
                                                        }
                                                    </div>
                                                )
                                            }
                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                        
                                                        <DateRange
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                       <div class="input-group-append">                                                                           
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                </div>
                            </div>

                        </div>

                        <div className="financial-table table-responsive sticky-header" id={slug !== 'idle-reports' ? 'table' : null}>
                            <table className="table table-hover table-bordered mb-0 bg-white">
                                <thead>
                                    <tr> 
                                        <td className="text-capitalize align-middle">S.No.</td>
                                        
                                        {thead.map((head, key) => {
                                            if( slug==='log-report'){
                                                return (<td className="text-capitalize align-middle" key={key}>{head['label'].replaceAll("_"," ")}</td>)      
                                            }
                                            if(head['label']==='Trigger  Status'){
                                                return (<td className="text-capitalize align-middle" key={key} style={{width:'10%'}}>{head['label']}</td>)
                                            }
                                           else{
                                                return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                            }
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody && tbody.map((body, key) => {
                                                return (<tr key={key}>
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        if (head['key'] === 'token_issue_date') {
                                                            return (<td>{body['token_issue_date'] ? moment(body['token_issue_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'discharge_date') {
                                                            return (<td>{body['discharge_date'] ? moment(body['discharge_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }

                                                        if (head['key'] === 'checkin_time') {
                                                            return (<td>{body['checkin_time'] ? moment(body['checkin_time']).format('LT') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'checkout_time') {
                                                            return (<td>{body['checkout_time'] ? moment(body['checkout_time']).format('LT') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'counselled_date') {
                                                            return (<td>{body['counselled_date'] ? moment(body['counselled_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'date_of_counselling') {
                                                            return (<td>{body['date_of_counselling'] ? moment(body['date_of_counselling']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'recounselling_time') {
                                                            return (<td>{body['recounselling_time'] ? moment(body['recounselling_time']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }

                                                        if (head['key'] === 'previous_estimate_time') {
                                                            return (<td>{body['previous_estimate_time'] ? moment(body['previous_estimate_time']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }

                                                        if (head['key'] === 'admitted_date') {
                                                            return (<td>{body['admitted_date'] ? moment(body['admitted_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }

                                                        if (head['key'] === 'admission_date') {
                                                            return (<td>{body['admission_date'] ? moment(body['admission_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'eighty_percent_reached_time') {
                                                            return (<td>{body['eighty_percent_reached_time'] ? moment(body['eighty_percent_reached_time']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }


                                                        if (head['key'] === 'discharge_date') {
                                                            return (<td>{body['discharge_date'] ? moment(body['discharge_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'final_estimate_date') {
                                                            return (<td>{body['final_estimate_date'] ? moment(body['final_estimate_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'date') {
                                                            return (<td>{body['date'] ? moment(body['date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'e_date_of_admission') {
                                                            return (<td>{body['e_date_of_admission'] ? moment(body['e_date_of_admission']).format('DD-MM-YYYY') : 'NA'}</td>)
                                                        }
                                                        
                                                        if (head['key'] === 'idle_start_time') {
                                                            return (<td>{body['idle_start_time'] ? moment(body['idle_start_time']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'idle_end_time') {
                                                            return (<td>{body['idle_end_time'] ? moment(body['idle_end_time']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'token_assigned_time') {
                                                            return (<td>{body['token_assigned_time'] ? moment(body['token_assigned_time']).format('LT') : 'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'extended_time') {
                                                            return (<td>{body['break_status']==='auto' ?'NA':body['extended_time']?body['extended_time']:'NA'}</td>)
                                                        }
                                                        if (head['key'] === 'reason') {
                                                            return (<td>{body['break_status']==='auto' ?'NA':body['reason']}</td>)
                                                        }
                                                        if (head['key'] === 'token_cancelled_at') {
                                                            return (<td>{body['token_cancelled_at']!==null ? moment(body['token_cancelled_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                        }
                                                        if(head['key'] === 'trackbills_flag_status') {
                                                            let text=body[head['key']] 
                                                            const trackbills_flag_status =text.split(",");
                                                            if(trackbills_flag_status.length>1){
                                                                return (<td style={{width:'10%'}}>
                                                                    {trackbills_flag_status.map((item, index)=>{
                                                                     return(<p>{index+1+'. '+item}</p>);
                                                                      })}
                                                                     </td>);
                                                            }else{
                                                                return (<td>
                                                                   <p>{trackbills_flag_status&&trackbills_flag_status!=""?'1. '+trackbills_flag_status:'NA'}</p>
                                                                     </td>); 
                                                            }
                                                        }
                                                        return (
                                                            <td className="text-capitalize">{(body[head['key']] !== null) ?(body[head['key']] !== "")?body[head['key']] :'NA': 'NA'}</td>
                                                        )

                                                    })
                                                    }

                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="13" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }

                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}

                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />


                        </div>
                    </div>

                </Spin>
            </div>
        )
    }
}

export default TAT_Report;